<template>
  <ComboPicker
    :label="label"
    :orientation="orientation"
    strings="operadora;a"
    icon="mdi-radio-tower"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todas as operadoras' : '(Todas)'"
    types="grouped-items"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { SimCard } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Operadora' },
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: []
    }
  },
  methods: {
    async fetchData() {
      let rows = await SimCard.findOperators()
      rows = rows.map(r => ({id: r, name: r}))
      this.allItems = orderBy(rows, [['name', 'asc']])
    }
  }
}

</script>

<style>

</style>